/**
 * ImmersiveBackBar — reusable top-left "← All genies" / back pill for the
 * immersive full-bleed Voice screens (gallery, hub, immersive-setup, distribute).
 * Brand tokens only; Lucide chevron for inline UI.
 */
import { ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface ImmersiveBackBarProps {
  /** Label after the chevron (defaults to "All genies") */
  label?: string;
  /** Route to navigate to (defaults to /genies). When omitted with onBack, calls onBack. */
  to?: string;
  onBack?: () => void;
  /** Optional right-aligned content (e.g. a CTA) */
  right?: React.ReactNode;
  className?: string;
}

export const ImmersiveBackBar = ({
  label = "All genies",
  to = "/genies",
  onBack,
  right,
  className,
}: ImmersiveBackBarProps) => {
  const navigate = useNavigate();
  const handle = () => {
    if (onBack) return onBack();
    navigate(to);
  };
  return (
    <div
      className={`h-14 flex-shrink-0 px-4 bg-white border-b border-[#F3F4F6] flex items-center justify-between gap-3 ${className ?? ""}`}
    >
      <button
        type="button"
        onClick={handle}
        className="inline-flex items-center gap-1.5 text-xs font-semibold text-gray-500 hover:text-genie-primary transition-colors"
      >
        <ChevronLeft className="w-4 h-4" />
        {label}
      </button>
      {right}
    </div>
  );
};

export default ImmersiveBackBar;
